var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 560,
    viewBox: "0 0 572 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_791_28695)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 572,
    height: 560,
    rx: 32,
    fill: "#18181B"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_791_28695)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 120,
    width: 320,
    height: 320,
    rx: 32,
    fill: "#26272B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 250,
    width: 172,
    height: 60,
    rx: 12,
    fill: "#3F3F46",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 252,
    width: 168,
    height: 56,
    rx: 11,
    fill: "#18181B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 308,
    width: 20,
    height: 2,
    fill: "url(#paint0_linear_791_28695)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 207,
    width: 20,
    height: 2,
    fill: "url(#paint1_linear_791_28695)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_791_28695)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 272,
    width: 19.4286,
    height: 32,
    rx: 4,
    fill: "url(#paint2_linear_791_28695)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_791_28695)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.429,
    y: 260,
    width: 19.4286,
    height: 44,
    rx: 4,
    fill: "url(#paint3_linear_791_28695)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_791_28695)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.857,
    y: 241,
    width: 19.4286,
    height: 63,
    rx: 4,
    fill: "url(#paint4_linear_791_28695)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_791_28695)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 276.286,
    y: 215,
    width: 19.4286,
    height: 89,
    rx: 4,
    fill: "url(#paint5_linear_791_28695)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_791_28695)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.714,
    y: 260,
    width: 19.4286,
    height: 44,
    rx: 4,
    fill: "url(#paint6_linear_791_28695)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_791_28695)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.143,
    y: 272,
    width: 19.4286,
    height: 32,
    rx: 4,
    fill: "url(#paint7_linear_791_28695)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_791_28695)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.571,
    y: 272,
    width: 19.4286,
    height: 32,
    rx: 4,
    fill: "url(#paint8_linear_791_28695)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408 120H164V186C164 188.209 165.791 190 168 190H183.679C185.114 190 186.44 189.231 187.152 187.985L196.848 171.015C197.56 169.769 198.886 169 200.321 169H371.63C373.091 169 374.436 169.797 375.138 171.079L384.362 187.921C385.064 189.203 386.409 190 387.87 190H404C406.209 190 408 188.209 408 186V120Z",
    fill: "url(#paint9_linear_791_28695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.5 186V120.5H407.5V186C407.5 187.933 405.933 189.5 404 189.5H387.87C386.591 189.5 385.414 188.803 384.8 187.681L375.577 170.839C374.787 169.397 373.274 168.5 371.63 168.5H200.321C198.706 168.5 197.215 169.365 196.414 170.767L186.718 187.736C186.094 188.827 184.935 189.5 183.679 189.5H168C166.067 189.5 164.5 187.933 164.5 186Z",
    stroke: "url(#paint10_linear_791_28695)",
    strokeOpacity: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408 440H164V374C164 371.791 165.791 370 168 370H183.679C185.114 370 186.44 370.769 187.152 372.015L196.848 388.985C197.56 390.231 198.886 391 200.321 391H371.63C373.091 391 374.436 390.203 375.138 388.921L384.362 372.079C385.064 370.797 386.409 370 387.87 370H404C406.209 370 408 371.791 408 374V440Z",
    fill: "url(#paint11_linear_791_28695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.5 374V439.5H407.5V374C407.5 372.067 405.933 370.5 404 370.5H387.87C386.591 370.5 385.414 371.197 384.8 372.319L375.577 389.161C374.787 390.603 373.274 391.5 371.63 391.5H200.321C198.706 391.5 197.215 390.635 196.414 389.233L186.718 372.264C186.094 371.173 184.935 370.5 183.679 370.5H168C166.067 370.5 164.5 372.067 164.5 374Z",
    stroke: "url(#paint12_linear_791_28695)",
    strokeOpacity: 0.04
  })), /*#__PURE__*/React.createElement("path", {
    d: "M276 250V169",
    stroke: "url(#paint13_linear_791_28695)",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 250V169",
    stroke: "url(#paint14_linear_791_28695)",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 310V391",
    stroke: "url(#paint15_linear_791_28695)",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 310V391",
    stroke: "url(#paint16_linear_791_28695)",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408 440V120",
    stroke: "url(#paint17_linear_791_28695)",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 328L427 232",
    stroke: "url(#paint18_linear_791_28695)",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 328L145 232",
    stroke: "url(#paint19_linear_791_28695)",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 440V120",
    stroke: "url(#paint20_linear_791_28695)",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 215L408 215",
    stroke: "url(#paint21_linear_791_28695)",
    strokeOpacity: 0.08,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 214,
    width: 11,
    height: 2,
    fill: "url(#paint22_linear_791_28695)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 2,
    transform: "matrix(-1 0 0 1 175 214)",
    fill: "url(#paint23_linear_791_28695)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 215,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2 203.067C163.6 202.533 164.4 202.533 164.8 203.067L168.8 208.4C169.294 209.059 168.824 210 168 210H160C159.176 210 158.706 209.059 159.2 208.4L163.2 203.067Z",
    fill: "#A0A0AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2 226.933C163.6 227.467 164.4 227.467 164.8 226.933L168.8 221.6C169.294 220.941 168.824 220 168 220H160C159.176 220 158.706 220.941 159.2 221.6L163.2 226.933Z",
    fill: "#A0A0AB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 190,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#333438"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 234.25,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#333438"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 256.375,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#333438"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 278.5,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#333438"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 300.625,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#333438"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 322.75,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#333438"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 344.875,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#333438"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 367,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#333438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 169V159",
    stroke: "url(#paint24_linear_791_28695)",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 391V401",
    stroke: "url(#paint25_linear_791_28695)",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_791_28695)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 327,
    width: 82,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeOpacity: 0.32,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_791_28695)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 330,
    width: 76,
    height: 28,
    rx: 14,
    fill: "url(#paint26_linear_791_28695)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.992 347.29V340.568H261.33V347.29H259.992ZM257.303 344.595V343.263H264.024V344.595H257.303ZM269.712 349.139C269.029 349.139 268.419 349.022 267.882 348.786C267.348 348.551 266.926 348.224 266.614 347.807C266.306 347.386 266.14 346.899 266.117 346.345H267.678C267.698 346.647 267.799 346.909 267.982 347.131C268.167 347.349 268.409 347.518 268.707 347.638C269.006 347.757 269.337 347.817 269.702 347.817C270.103 347.817 270.457 347.747 270.766 347.608C271.077 347.469 271.321 347.275 271.496 347.026C271.672 346.774 271.76 346.484 271.76 346.156C271.76 345.815 271.672 345.515 271.496 345.256C271.324 344.995 271.071 344.789 270.736 344.64C270.404 344.491 270.003 344.416 269.533 344.416H268.673V343.163H269.533C269.911 343.163 270.242 343.095 270.527 342.96C270.815 342.824 271.041 342.635 271.203 342.393C271.366 342.147 271.447 341.861 271.447 341.533C271.447 341.218 271.375 340.944 271.233 340.712C271.094 340.477 270.895 340.293 270.636 340.161C270.381 340.028 270.08 339.962 269.732 339.962C269.4 339.962 269.09 340.023 268.802 340.146C268.517 340.265 268.285 340.437 268.106 340.663C267.927 340.885 267.831 341.152 267.817 341.463H266.331C266.348 340.913 266.51 340.429 266.818 340.011C267.13 339.594 267.541 339.267 268.051 339.032C268.562 338.797 269.128 338.679 269.751 338.679C270.404 338.679 270.968 338.807 271.442 339.062C271.919 339.314 272.287 339.65 272.545 340.071C272.807 340.492 272.937 340.953 272.933 341.453C272.937 342.023 272.777 342.507 272.456 342.905C272.138 343.303 271.714 343.569 271.183 343.705V343.785C271.859 343.888 272.383 344.156 272.754 344.59C273.129 345.024 273.314 345.563 273.311 346.206C273.314 346.766 273.159 347.268 272.844 347.712C272.532 348.156 272.106 348.506 271.566 348.761C271.026 349.013 270.408 349.139 269.712 349.139ZM278.735 349.139C278.052 349.139 277.442 349.022 276.906 348.786C276.372 348.551 275.949 348.224 275.638 347.807C275.33 347.386 275.164 346.899 275.141 346.345H276.702C276.722 346.647 276.823 346.909 277.005 347.131C277.191 347.349 277.433 347.518 277.731 347.638C278.029 347.757 278.361 347.817 278.725 347.817C279.126 347.817 279.481 347.747 279.789 347.608C280.101 347.469 280.344 347.275 280.52 347.026C280.696 346.774 280.783 346.484 280.783 346.156C280.783 345.815 280.696 345.515 280.52 345.256C280.348 344.995 280.094 344.789 279.759 344.64C279.428 344.491 279.027 344.416 278.556 344.416H277.696V343.163H278.556C278.934 343.163 279.265 343.095 279.55 342.96C279.839 342.824 280.064 342.635 280.227 342.393C280.389 342.147 280.47 341.861 280.47 341.533C280.47 341.218 280.399 340.944 280.256 340.712C280.117 340.477 279.918 340.293 279.66 340.161C279.405 340.028 279.103 339.962 278.755 339.962C278.424 339.962 278.114 340.023 277.825 340.146C277.54 340.265 277.308 340.437 277.129 340.663C276.95 340.885 276.854 341.152 276.841 341.463H275.354C275.371 340.913 275.533 340.429 275.842 340.011C276.153 339.594 276.564 339.267 277.075 339.032C277.585 338.797 278.152 338.679 278.775 338.679C279.428 338.679 279.991 338.807 280.465 339.062C280.942 339.314 281.31 339.65 281.569 340.071C281.831 340.492 281.96 340.953 281.957 341.453C281.96 342.023 281.801 342.507 281.479 342.905C281.161 343.303 280.737 343.569 280.207 343.705V343.785C280.883 343.888 281.406 344.156 281.778 344.59C282.152 345.024 282.338 345.563 282.335 346.206C282.338 346.766 282.182 347.268 281.867 347.712C281.556 348.156 281.13 348.506 280.589 348.761C280.049 349.013 279.431 349.139 278.735 349.139ZM284.912 349.094C284.641 349.094 284.407 348.998 284.211 348.806C284.016 348.611 283.918 348.375 283.918 348.1C283.918 347.828 284.016 347.596 284.211 347.404C284.407 347.209 284.641 347.111 284.912 347.111C285.184 347.111 285.418 347.209 285.613 347.404C285.809 347.596 285.907 347.828 285.907 348.1C285.907 348.282 285.86 348.45 285.767 348.602C285.678 348.751 285.559 348.871 285.409 348.96C285.26 349.05 285.095 349.094 284.912 349.094ZM291.075 349.139C290.451 349.139 289.891 349.02 289.394 348.781C288.9 348.539 288.506 348.208 288.211 347.787C287.916 347.366 287.759 346.885 287.739 346.345H289.23C289.267 346.783 289.46 347.142 289.812 347.424C290.163 347.706 290.584 347.847 291.075 347.847C291.466 347.847 291.812 347.757 292.114 347.578C292.419 347.396 292.657 347.146 292.83 346.827C293.005 346.509 293.093 346.146 293.093 345.739C293.093 345.324 293.004 344.955 292.825 344.63C292.646 344.305 292.399 344.05 292.084 343.864C291.772 343.679 291.414 343.584 291.01 343.581C290.702 343.581 290.392 343.634 290.08 343.74C289.769 343.846 289.517 343.985 289.325 344.158L287.918 343.949L288.489 338.818H294.087V340.136H289.767L289.444 342.984H289.504C289.702 342.792 289.966 342.631 290.294 342.502C290.625 342.373 290.98 342.308 291.358 342.308C291.978 342.308 292.53 342.456 293.013 342.751C293.501 343.046 293.884 343.448 294.162 343.959C294.444 344.466 294.583 345.049 294.58 345.709C294.583 346.368 294.434 346.957 294.132 347.474C293.834 347.991 293.42 348.398 292.889 348.697C292.362 348.992 291.757 349.139 291.075 349.139ZM299.781 338.679C300.235 338.682 300.683 338.765 301.123 338.928C301.564 339.09 301.962 339.355 302.317 339.723C302.675 340.091 302.96 340.588 303.172 341.214C303.387 341.838 303.497 342.613 303.5 343.541C303.5 344.433 303.41 345.227 303.231 345.923C303.052 346.615 302.796 347.2 302.461 347.678C302.129 348.155 301.727 348.518 301.253 348.766C300.779 349.015 300.245 349.139 299.652 349.139C299.045 349.139 298.507 349.02 298.036 348.781C297.565 348.543 297.183 348.213 296.888 347.792C296.593 347.368 296.409 346.88 296.336 346.33H297.852C297.952 346.768 298.154 347.122 298.459 347.394C298.767 347.663 299.165 347.797 299.652 347.797C300.398 347.797 300.979 347.472 301.397 346.822C301.814 346.17 302.025 345.258 302.028 344.088H301.949C301.776 344.373 301.561 344.618 301.302 344.824C301.047 345.029 300.76 345.188 300.442 345.301C300.124 345.414 299.784 345.47 299.423 345.47C298.836 345.47 298.303 345.326 297.822 345.038C297.342 344.749 296.959 344.353 296.674 343.849C296.389 343.346 296.246 342.771 296.246 342.124C296.246 341.481 296.392 340.898 296.684 340.374C296.979 339.851 297.39 339.436 297.917 339.131C298.447 338.823 299.068 338.672 299.781 338.679ZM299.786 339.972C299.398 339.972 299.049 340.068 298.737 340.26C298.429 340.449 298.185 340.706 298.006 341.031C297.827 341.352 297.738 341.71 297.738 342.104C297.738 342.499 297.824 342.857 297.996 343.178C298.172 343.496 298.411 343.75 298.712 343.939C299.017 344.125 299.365 344.217 299.756 344.217C300.048 344.217 300.32 344.161 300.572 344.048C300.823 343.936 301.044 343.78 301.233 343.581C301.422 343.379 301.569 343.15 301.675 342.895C301.781 342.64 301.834 342.371 301.834 342.089C301.834 341.715 301.745 341.367 301.566 341.045C301.39 340.724 301.148 340.465 300.84 340.27C300.532 340.071 300.18 339.972 299.786 339.972ZM310.61 347.091V346.554C310.61 346.17 310.69 345.818 310.849 345.5C311.011 345.179 311.247 344.922 311.555 344.729C311.867 344.534 312.243 344.436 312.684 344.436C313.134 344.436 313.512 344.532 313.817 344.724C314.122 344.917 314.352 345.174 314.508 345.495C314.667 345.817 314.747 346.17 314.747 346.554V347.091C314.747 347.475 314.667 347.828 314.508 348.15C314.349 348.468 314.115 348.725 313.807 348.92C313.502 349.113 313.128 349.209 312.684 349.209C312.236 349.209 311.858 349.113 311.55 348.92C311.242 348.725 311.008 348.468 310.849 348.15C310.69 347.828 310.61 347.475 310.61 347.091ZM311.769 346.554V347.091C311.769 347.376 311.837 347.634 311.973 347.866C312.109 348.098 312.346 348.214 312.684 348.214C313.018 348.214 313.252 348.098 313.385 347.866C313.517 347.634 313.583 347.376 313.583 347.091V346.554C313.583 346.269 313.519 346.01 313.39 345.778C313.264 345.546 313.028 345.43 312.684 345.43C312.352 345.43 312.117 345.546 311.978 345.778C311.838 346.01 311.769 346.269 311.769 346.554ZM305.49 341.264V340.727C305.49 340.343 305.569 339.99 305.728 339.668C305.891 339.347 306.126 339.09 306.434 338.898C306.746 338.705 307.122 338.609 307.563 338.609C308.014 338.609 308.391 338.705 308.696 338.898C309.001 339.09 309.232 339.347 309.387 339.668C309.543 339.99 309.621 340.343 309.621 340.727V341.264C309.621 341.649 309.542 342.002 309.382 342.323C309.227 342.641 308.995 342.898 308.686 343.094C308.382 343.286 308.007 343.382 307.563 343.382C307.112 343.382 306.733 343.286 306.424 343.094C306.119 342.898 305.887 342.641 305.728 342.323C305.569 342.002 305.49 341.649 305.49 341.264ZM306.653 340.727V341.264C306.653 341.549 306.719 341.808 306.852 342.04C306.988 342.272 307.225 342.388 307.563 342.388C307.894 342.388 308.126 342.272 308.259 342.04C308.395 341.808 308.463 341.549 308.463 341.264V340.727C308.463 340.442 308.398 340.184 308.269 339.952C308.14 339.72 307.904 339.604 307.563 339.604C307.231 339.604 306.996 339.72 306.857 339.952C306.721 340.184 306.653 340.442 306.653 340.727ZM305.962 349L312.962 338.818H314.15L307.15 349H305.962Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.64,
    filter: "url(#filter10_f_791_28695)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 453,
    cy: 441,
    r: 119,
    fill: "#A855F7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_791_28695",
    x: 126,
    y: 120,
    width: 320,
    height: 320,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_791_28695"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.221844 0 0 0 0 0.225529 0 0 0 0 0.240267 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28695"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_791_28695",
    x: 206,
    y: 272,
    width: 20.4287,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28695"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_791_28695",
    x: 229.429,
    y: 260,
    width: 20.4287,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28695"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_791_28695",
    x: 252.857,
    y: 241,
    width: 20.4287,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28695"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_791_28695",
    x: 276.286,
    y: 215,
    width: 20.4287,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28695"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_791_28695",
    x: 299.714,
    y: 260,
    width: 20.4287,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28695"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_791_28695",
    x: 323.143,
    y: 272,
    width: 20.4287,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28695"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_791_28695",
    x: 346.571,
    y: 272,
    width: 20.4287,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28695"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_791_28695",
    x: 228,
    y: 326,
    width: 116,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 32
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_791_28695"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_791_28695",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_791_28695",
    x: 248,
    y: 330,
    width: 76,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_791_28695"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.640658 0 0 0 0 0.640658 0 0 0 0 0.640658 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28695"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_791_28695",
    x: 134,
    y: 122,
    width: 638,
    height: 638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_791_28695"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_791_28695",
    x1: 276,
    y1: 309,
    x2: 296,
    y2: 309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_791_28695",
    x1: 276,
    y1: 208,
    x2: 296,
    y2: 208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_791_28695",
    x1: 215.714,
    y1: 272,
    x2: 215.714,
    y2: 304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_791_28695",
    x1: 239.143,
    y1: 260,
    x2: 239.143,
    y2: 304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_791_28695",
    x1: 262.571,
    y1: 241,
    x2: 262.571,
    y2: 304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53535D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_791_28695",
    x1: 286,
    y1: 215,
    x2: 286,
    y2: 304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53535D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_791_28695",
    x1: 309.429,
    y1: 260,
    x2: 309.429,
    y2: 304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_791_28695",
    x1: 332.857,
    y1: 272,
    x2: 332.857,
    y2: 304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_791_28695",
    x1: 356.286,
    y1: 272,
    x2: 356.286,
    y2: 304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_791_28695",
    x1: 286,
    y1: 120,
    x2: 286,
    y2: 190,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333338",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333338"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_791_28695",
    x1: 286,
    y1: 190,
    x2: 286,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_791_28695",
    x1: 286,
    y1: 440,
    x2: 286,
    y2: 370,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333338",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333338"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_791_28695",
    x1: 286,
    y1: 370,
    x2: 286,
    y2: 440,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_791_28695",
    x1: 276.5,
    y1: 169,
    x2: 276.5,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_791_28695",
    x1: 296.5,
    y1: 169,
    x2: 296.5,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_791_28695",
    x1: 276.5,
    y1: 391,
    x2: 276.5,
    y2: 310,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_791_28695",
    x1: 296.5,
    y1: 391,
    x2: 296.5,
    y2: 310,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_791_28695",
    x1: 408.5,
    y1: 120,
    x2: 408.5,
    y2: 440,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_791_28695",
    x1: 427.5,
    y1: 232,
    x2: 427.5,
    y2: 328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_791_28695",
    x1: 145.5,
    y1: 232,
    x2: 145.5,
    y2: 328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_791_28695",
    x1: 164.5,
    y1: 120,
    x2: 164.5,
    y2: 440,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_791_28695",
    x1: 408,
    y1: 215.5,
    x2: 164,
    y2: 215.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_791_28695",
    x1: 397,
    y1: 215,
    x2: 408,
    y2: 215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_791_28695",
    x1: 0,
    y1: 1,
    x2: 11,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_791_28695",
    x1: 286.5,
    y1: 159,
    x2: 286.5,
    y2: 169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_791_28695",
    x1: 286.5,
    y1: 401,
    x2: 286.5,
    y2: 391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_791_28695",
    x1: 286,
    y1: 330,
    x2: 286,
    y2: 358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202025"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_791_28695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 572,
    height: 560,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock2);
export default __webpack_public_path__ + "static/media/block2.b30d1f3e11f35d95fa4aed6f3b595712.svg";
export { ForwardRef as ReactComponent };